export default "__VITE_ASSET__BOgNEYZH__"